/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { EsgService } from './services/esg.service';
import { EsgConsolidationService } from './services/esg-consolidation.service';
import { EsgFrameworkService } from './services/esg-framework.service';
import { EsgDisclosureDatapointService } from './services/esg-disclosure-datapoint.service';
import { EsgTicketService } from './services/esg-ticket.service';
import { DummyWorkaroundService } from './services/dummy-workaround.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    EsgService,
    EsgConsolidationService,
    EsgFrameworkService,
    EsgDisclosureDatapointService,
    EsgTicketService,
    DummyWorkaroundService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
